/**
 * Helper para establecer sesión de Cognito después de autenticación con VALId
 */

import {
  CognitoUser,
  CognitoUserPool,
  CognitoUserSession,
  CognitoAccessToken,
  CognitoIdToken,
  CognitoRefreshToken,
} from "amazon-cognito-identity-js";

import { addLastActivityCookie } from "./cookies";

const poolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
};

const userPool = new CognitoUserPool(poolData);

export interface CognitoTokens {
  AccessToken: string;
  IdToken: string;
  RefreshToken: string;
  ExpiresIn?: number;
  TokenType?: string;
}

/**
 * Establece la sesión de Cognito usando los tokens recibidos
 */
export const setValidCognitoSession = (
  username: string,
  tokens: CognitoTokens
): Promise<CognitoUserSession> => {
  return new Promise((resolve, reject) => {
    try {
      const cognitoUser = new CognitoUser({
        Username: username,
        Pool: userPool,
      });

      // Crear objetos de token de Cognito
      const accessToken = new CognitoAccessToken({
        AccessToken: tokens.AccessToken,
      });

      const idToken = new CognitoIdToken({
        IdToken: tokens.IdToken,
      });

      const refreshToken = new CognitoRefreshToken({
        RefreshToken: tokens.RefreshToken,
      });

      // Crear sesión
      const session = new CognitoUserSession({
        IdToken: idToken,
        AccessToken: accessToken,
        RefreshToken: refreshToken,
      });

      // Establecer la sesión en el usuario
      cognitoUser.setSignInUserSession(session);

      // Guardar cookie de última actividad
      addLastActivityCookie();

      console.log("Cognito session established successfully for:", username);
      resolve(session);
    } catch (error) {
      console.error("Error setting Cognito session:", error);
      reject(error);
    }
  });
};

